import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { submitContactForm } from "../api/contact";
import { seoDefaults } from "../utils/seoDefaults";
import SEO from "../api/seo";

const Contact = () => {
  const [loading, setLoading] = useState(true);
  const [submitStatus, setSubmitStatus] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitContactForm(formData);
      setSubmitStatus("success");
      toast.success("Message sent successfully!");
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      toast.error("Failed to send message.");
      setSubmitStatus("error");
    }
  };

  return (
    <>
      <SEO {...seoDefaults.contact} />
      <div className="min-h-screen bg-gradient-to-br from-[#0f0c29] via-[#302b63] to-[#24243e] text-white p-6 pt-28">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 to-purple-600  animate-pulse">
              Contact Us
            </h1>
          </div>

          <div className="bg-gray-900/80 p-10 rounded-2xl border border-purple-700 shadow-2xl backdrop-blur-lg">
            <div className="grid md:grid-cols-2 gap-10">
              <div>
                <iframe
                  className="rounded-2xl w-full h-64 md:h-full border-2 border-pink-600 shadow-lg"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63103.78588895155!2d77.6649711486328!3d8.692819800000002!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b040da5b105efaf%3A0x8822ba4ccf4763c4!2sGame%20Ztudio!5e0!3m2!1sen!2sin!4v1754982139609!5m2!1sen!2sin"
                  loading="lazy"
                ></iframe>
              </div>

              <div>
                <form onSubmit={handleSubmit} className="space-y-5">
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Your Name"
                    className="w-full p-4 rounded-2xl bg-gray-800 text-white border border-purple-600 focus:ring-2 focus:ring-pink-500"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Your Email"
                    className="w-full p-4 rounded-2xl bg-gray-800 text-white border border-purple-600 focus:ring-2 focus:ring-pink-500"
                    required
                  />
                  <textarea
                    name="message"
                    rows="5"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Your Message"
                    className="w-full p-4 rounded-2xl bg-gray-800 text-white border border-purple-600 focus:ring-2 focus:ring-pink-500"
                    required
                  ></textarea>
                  <button
                    type="submit"
                    className="w-full py-4 rounded-2xl bg-gradient-to-r from-cyan-400 to-purple-600  hover:from-purple-600 hover:to-cyan-400 text-white font-semibold shadow-xl transform hover:scale-105 transition"
                  >
                    Send Message
                  </button>
                  {submitStatus === "success" && (
                    <p className="text-green-400 mt-2 text-center">
                      Message sent successfully!
                    </p>
                  )}
                  {submitStatus === "error" && (
                    <p className="text-red-500 mt-2 text-center">
                      Failed to send message.
                    </p>
                  )}
                </form>
              </div>
            </div>

            <div className="grid md:grid-cols-3 gap-6 mt-12">
              <div className="bg-gray-800/90 p-6 rounded-2xl border border-purple-600 text-center shadow-lg hover:scale-105 transition">
                <i className="fas fa-map-marker-alt fa-2x mb-2 text-pink-500"></i>
                <h4 className="text-xl font-bold mb-1">Address</h4>
                <p className="text-gray-400">1st floor, Jeba Garden, FF 1/7 Corner stone complex, NGO A colony, Tirunelveli</p>
              </div>
              <div className="bg-gray-800/90 p-6 rounded-2xl border border-purple-600 text-center shadow-lg hover:scale-105 transition">
                <i className="fas fa-envelope fa-2x mb-2 text-pink-500"></i>
                <h4 className="text-xl font-bold mb-1">Email</h4>
                 <a
                    href="mailto:info@gameztudio.com">
                <p className="text-gray-400 hover:text-cyan-400">info@gameztudio.com</p></a>
              </div>
              <div className="bg-gray-800/90 p-6 rounded-2xl border border-purple-600 text-center shadow-lg hover:scale-105 transition">
                <i className="fas fa-phone-alt fa-2x mb-2 text-pink-500"></i>
                <h4 className="text-xl font-bold mb-1">Phone</h4>
                  <a
                    href="tel:+918098044400">
                <p className="text-gray-400 hover:text-cyan-400">+91 80980 44400</p></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
